module.exports = __webpack_public_path__ + "static/media/icon-humidity-dark.6db383d2.svg";